export function isRoof(o: IFloor | IRoof | IFacade): o is IRoof {
    return (o as IRoof).isRoof;
}
export function isOther(o: IOther | IBuilding): o is IOther {
    return (o as IOther).isOther;
}